import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const TEMPORARY_PERMISSION_CREATE_RESOURCE = "temporary-permission" as const;
export const TEMPORARY_PERMISSION_CREATE_API_PATH = `/v1/${TEMPORARY_PERMISSION_CREATE_RESOURCE}` as const;

export type TemporaryPermissionCreateBody =
  paths[typeof TEMPORARY_PERMISSION_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type TemporaryPermissionCreateResponse =
  paths[typeof TEMPORARY_PERMISSION_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useTemporaryPermissionCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TemporaryPermissionCreateResponse, Error, TemporaryPermissionCreateBody>({
    mutationFn: async (tempPerm: TemporaryPermissionCreateBody) => {
      const response = await alphartisApiAxios.post<TemporaryPermissionCreateResponse>(
        TEMPORARY_PERMISSION_CREATE_API_PATH,
        tempPerm,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [TEMPORARY_PERMISSION_CREATE_RESOURCE],
      });
    },
  });
};
